import React from "react"
import { useSelector } from "react-redux"

import { MtAccountPackage } from "server/models"
import {
    StoreType,
    ActivePackageDaysLeft,
} from "client/store"
import {
    DateFormatter,
    TableColumn,
} from "client/components"

const Columns = () => {
    const packageList = useSelector((state: StoreType) => state.package.packageList)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const columns: TableColumn[] = [
        {
            field: "package",
            header: lang.activePackage,
            cellMinWidth: "200px",
            formatter: (row: MtAccountPackage) => {
                const { packageId } = row
                const packg = packageList[packageId] || null
                if (!packg) return null
                return packg.name
            },
        },
        {
            field: "dateStart",
            header: lang.dateStart,
            formatter: (row: MtAccountPackage) => <DateFormatter date={row.dateStart} />,
        },
        {
            field: "dateEnd",
            header: lang.dateEnd,
            formatter: (row: MtAccountPackage) => <DateFormatter date={row.dateEnd} />,
        },
        {
            field: "daysLeft",
            header: lang.daysLeft,
            cellMinWidth: "100px",
            formatter: (row: MtAccountPackage) => ActivePackageDaysLeft(row.dateEnd),
        },
    ]

    return columns
}
export default Columns
